import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MieterDaten} from '../models/mieter-daten.model';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {NotificationsInfo} from '../models/notifications-info.model';
import {LoginError} from '../models/login-error.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private currentMieterListSubject: BehaviorSubject<MieterDaten[]>;
  public currentMieterList: Observable<MieterDaten[]>;
  private currentMieterDatenSubject: BehaviorSubject<MieterDaten>;
  public currentMieterDaten: Observable<MieterDaten>;
  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = window.location.href.includes('localhost') ? 'https://localhost:8443/api' : 'https://socsng2019.mess-profis.de:8443/api';
    if (window.location.href.includes('mieterportal.mess')) this.baseUrl = 'https://mieterportal.mess-profis.de/api';
    this.currentMieterListSubject = new BehaviorSubject<MieterDaten[]>(null);
    this.currentMieterList = this.currentMieterListSubject.asObservable();
    this.currentMieterDatenSubject = new BehaviorSubject<MieterDaten>(null);
    this.currentMieterDaten = this.currentMieterDatenSubject.asObservable();
  }

  public selectMieterDaten(daten: MieterDaten): void {
    this.currentMieterDatenSubject.next(daten);
  }

  public resetData(): void {
    this.currentMieterListSubject = new BehaviorSubject<MieterDaten[]>(null);
    this.currentMieterList = this.currentMieterListSubject.asObservable();
  }

  public get currentMieterListValue(): MieterDaten[] {
    return this.currentMieterListSubject.value;
  }

  public get currentMieterDatenValue(): MieterDaten {
    return this.currentMieterDatenSubject.value;
  }

  public getDataForUser(email: string, password: string): Observable<MieterDaten[] | LoginError> {
    return this.http.post<MieterDaten[] | LoginError>(this.baseUrl + '/Mieter/Login', {
      Mail: email,
      PasswordHash: password
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).pipe(map((values: MieterDaten[]) => {
        sessionStorage.setItem('token', JSON.stringify('tbd'));
        sessionStorage.setItem('user', email);
        this.currentMieterListSubject.next(values);
        return values;
      }
    ));
  }

  public getNotificationsInfo(key: string): Observable<NotificationsInfo> {
    return this.http.post<NotificationsInfo>(this.baseUrl + '/Mieter/NotificationsInfo', {key}, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).pipe(map((values: NotificationsInfo) => {
        return values;
      }
    ));
  }

  public changeUserPassword(email: string, passwordOld: string, passwordNewRaw: string): Observable<any> {
    return this.http.post<MieterDaten>(this.baseUrl + '/Mieter/ChangePassword', {
      Mail: email,
      PasswordHashOld: passwordOld,
      PasswordNew: passwordNewRaw
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public editNotifications(key: string, state: boolean): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/Mieter/EditNotifications', {
      Key: key,
      State: state
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public checkActivationExistingBenutzer(email: string): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Mieter/CheckActivationExistingBenutzer', {
      Email: email
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).pipe(map((values: boolean) => {
        return values;
      }
    ));
  }

  public activateAccount(key: string, email: string, password: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/Mieter/ActivateAccount', {
      ActivationKey: key,
      Email: email,
      Password: password
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public resetPassword(email: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/Mieter/ResetAccount', {
      Email: email.trim()
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  public resetPasswordConfirm(key: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/Mieter/ResetAccountConfirm', {
      Key: key
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}
